import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';

/**
 * Header actions component that manages cart notifications.
 *
 * @typedef {object} Refs
 * @property {HTMLElement} liveRegion - The live region for cart announcements.
 *
 * @extends {Component<Refs>}
 */
class HeaderActions extends Component {
  requiredRefs = ['liveRegion'];

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(ThemeEvents.cartUpdate, this.#onCartUpdate);
    this.#styleAccountCoin();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(ThemeEvents.cartUpdate, this.#onCartUpdate);
  }

  /**
   * Applies font-size to the signed-in avatar coin (shadow DOM; not exposed via CSS vars).
   */
  #styleAccountCoin = async () => {
    await customElements.whenDefined('shopify-account');
    const account = this.querySelector('shopify-account');
    const shadowRoot = account?.shadowRoot;
    if (!shadowRoot || shadowRoot.getElementById('account-coin-styles')) return;

    const style = document.createElement('style');
    style.id = 'account-coin-styles';
    style.textContent =
      '.account-button__coin-front { font-size: 15px; border-color: #3c3c3c; }';
    shadowRoot.appendChild(style);
  };

  /**
   * Handles cart update events and announces the new count to screen readers.
   * @param {CustomEvent<{ resource?: { item_count?: number } }>} event
   */
  #onCartUpdate = (event) => {
    const cartCount = event.detail.resource?.item_count;
    if (cartCount === undefined) return;

    this.refs.liveRegion.textContent = `${Theme.translations.cart_count}: ${cartCount}`;
  };
}

if (!customElements.get('header-actions')) {
  customElements.define('header-actions', HeaderActions);
}
